import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function ProductIntelligence() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    api.get("/product-intelligence", { params: { q: q || undefined } }).then(({ data }) => setRows(data.items || []));
  }, [q]);
  return (
    <div className="space-y-4 max-w-[1600px]">
      <div>
        <div className="text-[10px] font-semibold tracking-[0.08em] uppercase text-slate-500">Asset Intelligence</div>
        <h1 className="text-2xl font-heading font-semibold text-slate-900 tracking-tight">Product Intelligence</h1>
        <p className="text-sm text-slate-500 mt-0.5">Lifecycle metadata for every product family — launch, end-of-support, refresh cadence.</p>
      </div>
      <Input placeholder="Search model, manufacturer or SKU…" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-md h-9" />
      <div className="bg-white border border-slate-200 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-[10px] uppercase tracking-widest">
            <tr>
              <th className="px-3 py-2 text-left">Manufacturer</th>
              <th className="px-3 py-2 text-left">Model</th>
              <th className="px-3 py-2 text-left">SKU</th>
              <th className="px-3 py-2 text-left">Launched</th>
              <th className="px-3 py-2 text-left">End of support</th>
              <th className="px-3 py-2 text-left">Refresh</th>
              <th className="px-3 py-2 text-left">Warranty</th>
              <th className="px-3 py-2 text-left">Source</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-slate-100">
                <td className="px-3 py-2 font-medium">{r.manufacturer}</td>
                <td className="px-3 py-2">{r.model}</td>
                <td className="px-3 py-2 font-mono text-xs">{r.sku || "—"}</td>
                <td className="px-3 py-2 text-xs">{r.launch_date || "—"}</td>
                <td className="px-3 py-2 text-xs">{r.end_of_support || "—"}</td>
                <td className="px-3 py-2 text-xs">{r.recommended_refresh_months ? `${r.recommended_refresh_months}m` : "—"}</td>
                <td className="px-3 py-2 text-xs">{r.warranty_default_months ? `${r.warranty_default_months}m` : "—"}</td>
                <td className="px-3 py-2 text-xs uppercase tracking-widest text-slate-500">{r.source}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
